module.exports = __webpack_public_path__ + "static/4_2_recommendation_EE-01737249f1f71b9c5a57d2d9cefa1b8a.svg";